/* eslint-disable no-underscore-dangle */

import queryString from 'query-string';

const baseUrl = 'https://sb.scorecardresearch.com/b';
const baseName = 'labs.op3.iran-sancties';

const defaultParameters = {
  c1: '2',
  c2: '17827132',
  potag1: 'nosop3',
  potag2: 'nosop3',
  potag3: 'nos',
  potag4: 'nos',
  potag5: 'programma',
  potag6: 'video',
  potag7: 'npo3',
  potag8: 'site',
  potag9: 'site',
  nos_project: 'nos-labs',
  nos_event: 'iran-sancties',
  ns_site: 'po-totaal',
};

export default function track(parameters) {
  const fullParameters = Object.assign({}, defaultParameters, parameters);

  if (process.env.NODE_ENV === 'development') {
    console.log('[TRACKING]', fullParameters.name, fullParameters); // eslint-disable-line no-console
  }

  const url = `${baseUrl}?${queryString.stringify(fullParameters)}`;
  window.udm_(url);
}

export function trackSection(name) {
  track({
    name: `${baseName}.${name}`,
    nos_title: name,
    nos_labs_section: name,
  });
}

export function trackVideo(name, event) {
  track({
    name: `${baseName}.${name}`,
    nos_title: event,
    ns_type: 'hidden',
  });
}



// WEBPACK FOOTER //
// ./src/utils/track.js